export const stringsKey = "IVRFlowConfiguration";
export const englishStrings = {
	errorMessage: "Failed to load flow configuration detail!",
	flowHeader: "IVR Flow Configuration",
	saveButton: "Save",
	saveFlowDetailErrorMessage:
		"Error submitting flow configuration detail, please try again",
	saveFlowDetailSuccessMessage: "Flow configuration detail saved successfully",
	ussdScriptErrorMessage: "Error loading USSD script detail, please try again",
	generateScriptButton: "Generate Script",
};
